import { render, staticRenderFns } from "./operations.vue?vue&type=template&id=48b2e310&"
import script from "./operations.vue?vue&type=script&lang=js&"
export * from "./operations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports